import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  updateDoc,
  addDoc,
} from "firebase/firestore";

const firestore = getFirestore();

export const addCar = createAsyncThunk("cars/addCar", async (newCar) => {
  const carRef = await addDoc(collection(firestore, "cars"), newCar);
  return { id: carRef.id, ...newCar };
});

export const fetchCars = createAsyncThunk("cars/fetchCars", async () => {
  const carSnapshot = await getDocs(collection(firestore, "cars"));
  return carSnapshot.docs
    .map((doc) => ({ id: doc.id, ...doc.data() }))
    .filter((car) => car.status !== "deleted");
});

export const removeCar = createAsyncThunk("cars/removeCar", async (carId) => {
  const carDoc = doc(firestore, "cars", carId);
  await updateDoc(carDoc, { status: "deleted" });
  return carId;
});

export const setCarInactive = createAsyncThunk(
  "cars/setCarInactive",
  async (carId) => {
    const carDoc = doc(firestore, "cars", carId);
    await updateDoc(carDoc, { status: "inactive" });
    return carId;
  }
);

export const activateCar = createAsyncThunk(
  "cars/activateCar",
  async (carId) => {
    const carDoc = doc(firestore, "cars", carId);
    await updateDoc(carDoc, { status: "active" });
    return carId;
  }
);

const carsSlice = createSlice({
  name: "cars",
  initialState: {
    carsList: [],
  },
  reducers: {
    addCar: (state, action) => {
      state.carsList.push(action.payload); // Update this line
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(setCarInactive.fulfilled, (state, action) => {
        const index = state.carsList.findIndex(
          (car) => car.id === action.payload
        );
        if (index !== -1) {
          state.carsList[index].status = "inactive";
        }
      })
      .addCase(fetchCars.fulfilled, (state, action) => {
        state.carsList = action.payload; // Update this line
      })
      .addCase(removeCar.fulfilled, (state, action) => {
        const index = state.carsList.findIndex(
          (car) => car.id === action.payload
        ); // Update this line
        if (index !== -1) {
          state.carsList[index].status = "deleted"; // Update this line
        }
      })
      .addCase(activateCar.fulfilled, (state, action) => {
        const index = state.carsList.findIndex(
          (car) => car.id === action.payload
        );
        if (index !== -1) {
          state.carsList[index].status = "active";
        }
      })
      .addCase(addCar.fulfilled, (state, action) => {
        state.carsList.push(action.payload);
      });
  },
});

export const { carAdded } = carsSlice.actions;

export default carsSlice.reducer;
